module.exports = __webpack_public_path__ + "static/4.5.1_ADIDAS_WW.V2-1ddb181ab5024fbae13d223096a25009.gif";